// extracted by mini-css-extract-plugin
export default {"main":"styles_main__UTX50","img_side":"styles_img_side__sauPg","form_side":"styles_form_side__b+YUP"};